module.exports = __webpack_public_path__ + "img/horizontal_7_1_0.c86e0ec8.png";